export default "__VITE_ASSET__Bk2ps1Jd__"